import React, { Component } from 'react';
import { ReactComponent as Circle } from '../../../images/icons/circle.svg';
import { StyledIcon } from './Dot.styled';

export class Dot extends Component<any, any> {
  render() {
    // Prefer transient `$isActive` prop which will not be forwarded to DOM.
    const isActive = this.props.$isActive;
    return (
      <StyledIcon $isActive={isActive}>
        <Circle />
      </StyledIcon>
    );
  }
}
